import makeFilterResultTopic from "./filter-search-result/filter-search-result-factory";
import makeFilterTopic from "./filter-topic/filter-topic-factory";

/**
 * Returns all magazines as present in DOM.
 * @returns {{number: number, month: string, year: number, title: string}[]}
 */
export function getMagazines() {
    const getTitlesElements = () => Array.prototype.slice.call(document.querySelectorAll(".catalogues-magazine-title"))
    return getTitlesElements().map(titleElement => {
        const title = titleElement.querySelector("a").innerText
        const number = titleElement.previousElementSibling.innerText
        const month = titleElement.closest(".catalogues-magazine-section").querySelector(".catalogues-month div").innerText
        const year = titleElement.closest(".catalogues-magazine-container").previousElementSibling.innerText
        return {title, number, month, year}
    });
}

const magazines = getMagazines()

function setSearchResult(results) {
    searchResultTopic.set(results.sort(({year: a}, {year: b}) => b - a))
}
function isFilterSet() {
    return filterTopic.isFilterSet()
}

const searchResultTopic = makeFilterResultTopic(isFilterSet)
const filterTopic = makeFilterTopic(magazines, setSearchResult)

export function initSearch() {
    return {filterTopic}
}